import type { ReactElement } from 'react';
import { BrandLogo, cn } from '@/shared/ui';
import type { HeaderIntroPhase } from './use-header-intro';

interface SiteHeaderIntroProps {
  /** logo = 막을 덮고 로고가 떠오른다, reveal = 막이 위로 걷힌다. done 이면 그리지 않는다. */
  readonly phase: Exclude<HeaderIntroPhase, 'done'>;
}

/**
 * HOME 첫 진입 막 — 화면 전체를 덮는 흑연 막 가운데 흰 SS 로고가 떠오르고, 그 아래 라임 선이 가운데서
 * 양옆으로 그어진 뒤, 막이 위로 걷히며 사진이 드러난다. 장식이라 보조기기·키보드는 건너뛴다.
 * 걷힐 때는 잘라 내기(clip-path)만 해서 아래 화면 레이아웃이 움직이지 않는다.
 */
export const SiteHeaderIntro = ({ phase }: SiteHeaderIntroProps): ReactElement => (
  <div
    aria-hidden
    inert
    data-phase={phase}
    className={cn(
      'pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-primary text-white transition-[clip-path] duration-[900ms] ease-[cubic-bezier(0.76,0,0.24,1)]',
      phase === 'logo' ? '[clip-path:inset(0_0_0_0)]' : '[clip-path:inset(0_0_100%_0)]',
    )}
  >
    <div
      className={cn(
        'flex flex-col items-center gap-5 transition-[opacity,translate] duration-500 ease-out',
        phase === 'reveal' && '-translate-y-6 opacity-0',
      )}
    >
      <BrandLogo className="h-12 animate-fade-up sm:h-16" />
      <span className="block h-px w-40 origin-center animate-intro-line bg-brand-lime sm:w-56" />
    </div>
  </div>
);
